/**
 * @author rmh
 */

// 采购分仓
import { SubWarehouseService } from './procurementSubWarehouse'

// 定向采购
import { TargetedProcurementService } from './targetedProcurement'

// 版别关联供应商
import { VersionAssociatedSupplierService } from './versionAssociatedSupplier'
// 退货申请单管理
import { ReturnRequestFormService } from './ReturnRequestForm'
// 回告异常
import { reportExceptionHandlingService } from './reportExceptionHandling'
// 采购单管理
import { purchaseOrderListService } from './purchaseOrderList'
// 采购调整单管理
import { procurementAdjustmentService } from './procurementAdjustment'
// 采购需求管理-中心内接口调用
import { centralInternalService } from './centralInternal'
// 采购单详情管理
import { purchaseOrderDetailsService } from './purchaseOrderDetails'
// 进退单
import { entryAndExitFormService } from './entryAndExitForm'

export const subWarehouse = new SubWarehouseService('/api/procure/warehouseConfig')

export const versionAssociatedSupplier = new VersionAssociatedSupplierService('/api/procure/editionConfig')

export const targetedProcurement = new TargetedProcurementService('/api/procure/orientConfig')

export const returnRequestForm = new ReturnRequestFormService('/api/procure/return/apply')

export const reportExceptionHandling = new reportExceptionHandlingService('/api/procure/return')

export const purchaseOrderList = new purchaseOrderListService('/api/procure/order')

export const procurementAdjustment = new procurementAdjustmentService('/api/procure/adjust')

export const centralInternal = new centralInternalService('/api/procure/require/internal')

export const purchaseOrderDetails = new purchaseOrderDetailsService('/api/procure/order/detail')

export const entryAndExitForm = new entryAndExitFormService('/api/procure/return/order')
